"use client";

import Link from "next/link";
import { useTranslations, useLocale } from "next-intl";
import styles from "./Footer.module.css";
import Logo from "./Logo";

export default function Footer() {
  const t = useTranslations('footer');
  const locale = useLocale();

  return (
    <footer id="site-footer" className={styles.footer}>
      <div className={styles.container}>
        {/* Logo and Brand */}
        <div className={styles.brandSection}>
          <Link href={`/${locale}`} className={styles.logoLink} aria-label="Interface Audit">
            <Logo variant="desktop" className={styles.logo} />
          </Link>
        </div>

        {/* Product Links */}
        <nav className={styles.navLinks} aria-label="Product">
          <Link href={`/${locale}/audit`} className={styles.navLink}>
            {t('freeAudit')}
          </Link>
          <Link href={`/${locale}/chat`} className={styles.navLink}>
            {t('chat')}
          </Link>
          <Link href={`/${locale}/criteria`} className={styles.navLink}>
            {t('criteria')}
          </Link>
          <Link href={`/${locale}/discovery-call`} className={styles.navLink}>
            {t('discoveryCall')}
          </Link>
        </nav>

        {/* Legal & Contact Links */}
        <nav className={styles.navLinks} aria-label="Legal">
          <Link href={`/${locale}/terms`} className={styles.navLink}>
            {t('terms')}
          </Link>
          <Link href={`/${locale}/privacy`} className={styles.navLink}>
            {t('privacy')}
          </Link>
          <Link href={`/${locale}/refunds`} className={styles.navLink}>
            {t('refunds')}
          </Link>
          <a
            href="mailto:hello@interfaceaudit.com"
            className={styles.navLink}
          >
            Contact
          </a>
        </nav>

        {/* Copyright */}
        <p className={styles.copyright}>
          © {new Date().getFullYear()} Interface Audit. Made with{" "}
          <span className={styles.heart} aria-label="love">❤️</span> by InterfaceAudit.com
        </p>
      </div>
    </footer>
  );
}
